export type Value = string | Date | [string | Date, string | Date];

export enum VerificationStatus {
	UNVERIFIED = 'UNVERIFIED',
	VERIFIED = 'VERIFIED'
}

export type VerificationInfo = {
	value: string;
	status: VerificationStatus
}

export type User = {
	id?: number;
	name?: string;
	firstName?: string;
	lastName?: string;
	email?: VerificationInfo,
	phone?: VerificationInfo,
	userStatus?: string;
	language?: string;
	registrationDate?: string;
	confirmed?: true,
	confirmationDate?: string;
	password?: string;
	passwordConfirmation?: string;
	roles?: string[];
}
